/** カート合計と国内の通常配送案内。BSS適用時の価格描画はアプリに任せる。 */
(function () {
  'use strict';

  if (window.freeShippingNoticeInitialized) return;
  window.freeShippingNoticeInitialized = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cart = null;
  var revision = 0;
  var fetching = false;
  var hookRegistered = false;
  var completedBssCart = '';
  var fallbackTimer;
  var pollTimer;
  var pollCount = 0;

  // 割引・行識別子・数量のいずれかが違えば、同じカートの計算結果とは扱わない。
  function signature(value) {
    if (!value || !Array.isArray(value.items)) return '';
    return JSON.stringify([
      value.currency, value.total_price, value.total_discount,
      (value.cart_level_discount_applications || []).map(function (discount) {
        return [discount.title, discount.total_allocated_amount];
      }).sort(),
      value.items.map(function (item) { return [item.key, item.quantity]; }).sort(),
    ]);
  }

  function totals() {
    return document.querySelectorAll('[data-cart-price-mode]');
  }

  function notice(state, text) {
    document.querySelectorAll('[data-free-shipping-container]').forEach(function (container) {
      var element = container.querySelector('[data-free-shipping-notice]');
      if (!element) return;
      element.classList.remove('is-pending', 'is-achieved', 'is-unavailable');
      if (state) element.classList.add('is-' + state);
      if (element.textContent !== text) element.textContent = text;
      container.dataset.freeShippingState = state;
      container.setAttribute('aria-busy', state === 'pending' ? 'true' : 'false');
    });
  }

  function mode(value, text) {
    totals().forEach(function (element) {
      var confirmed = element.querySelector('[data-confirmed-cart-total]');
      if (confirmed && text !== undefined && confirmed.textContent !== text) confirmed.textContent = text;
      if (element.dataset.cartPriceMode !== value) element.dataset.cartPriceMode = value;
      element.setAttribute('aria-busy', value === 'pending' ? 'true' : 'false');
    });
  }

  function formatMoney(cents) {
    var bss = window.BSS_B2B;
    if (bss && typeof bss.formatMoney === 'function') return bss.formatMoney(cents);
    return new Intl.NumberFormat(document.documentElement.lang || 'ja-JP', {
      style: 'currency', currency: cart.currency,
    }).format(cents / 100);
  }

  function hasUnconfirmedGift() {
    return cart.items.some(function (item) {
      return item.properties && item.properties._auto_gift && item.final_line_price !== 0;
    });
  }

  function hasShippingCode() {
    var titles = new Set((cart.cart_level_discount_applications || []).map(function (discount) {
      return discount.title.toLowerCase();
    }));
    cart.items.forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (allocation) {
        titles.add(allocation.discount_application.title.toLowerCase());
      });
    });
    // 金額割引に現れない適用済みコードは、送料割引などの可能性がある。
    return (cart.discount_codes || []).some(function (code) {
      return code.applicable && !titles.has(code.code.toLowerCase());
    });
  }

  function hasCustomShipping(bss) {
    if (!bss || !bss.sr || !bss.sr.status) return false;
    var rules = bss.sr.srRules;
    var utils = bss.utils;
    if (!Array.isArray(rules) || !utils || ['checkCustomer', 'checkExcludeCustomer', 'checkMarket', 'checkDateAndTime']
      .some(function (name) { return typeof utils[name] !== 'function'; })) return true;
    return rules.some(function (rule) {
      return utils.checkCustomer(rule) && !utils.checkExcludeCustomer(rule) &&
        utils.checkMarket(rule) && utils.checkDateAndTime(rule);
    });
  }

  function renderShipping(bssPrice) {
    var bss = window.BSS_B2B;
    if (bssPrice || hasCustomShipping(bss) || hasUnconfirmedGift() || hasShippingCode() ||
      !window.Shopify || window.Shopify.country !== 'JP') {
      notice('unavailable', '配送先や割引に応じた送料は、購入手続きでご確認ください');
      return;
    }
    document.querySelectorAll('[data-free-shipping-container]').forEach(function (container) {
      var threshold = Number(container.dataset.thresholdCents);
      var remaining = threshold - cart.total_price;
      if (remaining > 0) {
        notice('', 'あと ' + new Intl.NumberFormat('ja-JP').format(Math.ceil(remaining / 100)) + '円 で通常配送が無料です');
      } else {
        notice('achieved', '通常配送が無料になります');
      }
    });
  }

  function render() {
    if (!cart || fetching) return;
    var bss = window.BSS_B2B;
    if (!bss) {
      mode('shopify', formatMoney(cart.total_price));
      renderShipping(false);
      window.clearTimeout(fallbackTimer);
      return;
    }
    var storage = bss.storage && bss.storage.cartStorage;
    if (!hookRegistered || completedBssCart !== signature(cart) || !storage || !bss.utils ||
      typeof storage.get !== 'function' || typeof bss.utils.getModifyPrice !== 'function') return;

    var bssPrice = false;
    // BSSの総額や固定タグを使わず、最新カートの各行に実際に適用された価格を確認する。
    for (var item of cart.items) {
      var priced = storage.get(item.key);
      if (!priced || priced.quantity !== item.quantity) return;
      var price = bss.utils.getModifyPrice(priced, priced.bssB2bShowPriceKey);
      if (typeof price === 'number' || priced.bssB2bShowPriceKey === 'td' || priced.bssB2bShowPriceKey === 'mc') {
        bssPrice = true;
      }
    }
    mode(bssPrice ? 'bss' : 'shopify', bssPrice ? undefined : formatMoney(cart.total_price));
    renderShipping(bssPrice);
    window.clearTimeout(fallbackTimer);
  }

  function registerBssHook() {
    var bss = window.BSS_B2B;
    if (!hookRegistered && bss && bss.custom && typeof bss.custom.addAction === 'function') {
      bss.custom.addAction('custom:cart/showSubtotalPrice', function () {
        completedBssCart = signature(bss.shopData && bss.shopData.cart);
        // 他のアプリからのカート更新も、Shopifyの最新金額を読み直してから反映する。
        if (cart && !fetching && completedBssCart && completedBssCart !== signature(cart)) refresh();
        else render();
      }, 1000);
      hookRegistered = true;
    }
    if (!cart || fetching || !hookRegistered) return;
    // 初回計算がフック登録前に終わった場合も、最新カートに属する計算データを確認する。
    // DOMの表示用属性や、以前のカートのBSS合計だけでは完了と扱わない。
    var calculated = bss.shopData && bss.shopData.cart;
    if (bss.isFirstLoad === false && calculated && Number.isFinite(calculated.bss_b2b_total_price) &&
      signature(calculated) === signature(cart)) {
      completedBssCart = signature(calculated);
    }
    render();
  }

  function pollForBss() {
    window.clearTimeout(pollTimer);
    registerBssHook();
    if (++pollCount < 100 && totals().length &&
      Array.from(totals()).some(function (element) { return element.dataset.cartPriceMode === 'pending'; })) {
      pollTimer = window.setTimeout(pollForBss, 100);
    }
  }

  function refresh() {
    var current = ++revision;
    fetching = true;
    completedBssCart = '';
    mode('pending', '合計を確認しています…');
    notice('pending', '送料無料条件を確認しています…');
    window.clearTimeout(fallbackTimer);
    fallbackTimer = window.setTimeout(function () {
      if (current !== revision) return;
      mode('unavailable', '購入手続きで金額をご確認ください');
      notice('unavailable', '送料は購入手続きでご確認ください');
    }, 8000);

    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (response) {
        if (!response.ok) throw new Error('カート金額を取得できませんでした。');
        return response.json();
      })
      .then(function (value) {
        if (current !== revision) return;
        if (!Array.isArray(value.items) || !Number.isFinite(value.total_price)) throw new Error('カート金額を確認できませんでした。');
        cart = value;
        fetching = false;
        pollCount = 0;
        registerBssHook();
        render();
        pollForBss();
      })
      .catch(function () {
        if (current !== revision) return;
        fetching = false;
        mode('unavailable', '購入手続きで金額をご確認ください');
        notice('unavailable', '送料は購入手続きでご確認ください');
      });
  }

  function initialize() {
    if (!totals().length) return;
    refresh();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      // 表示用GETをpublishの完了待ちに含めず、プレゼント・ラッピングの更新順序を保つ。
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { refresh(); });
    }
    // セクション差し替え後の新しい合計要素を、BSSの再描画対象とは別に管理する。
    new MutationObserver(function (records) {
      if (records.some(function (record) {
        return Array.from(record.addedNodes).some(function (node) {
          return node.nodeType === 1 && (node.matches('[data-cart-price-mode]') || node.querySelector('[data-cart-price-mode]'));
        });
      })) refresh();
    }).observe(document.getElementById('main-cart-footer'), { childList: true, subtree: true });
    window.addEventListener('pageshow', function (event) { if (event.persisted) refresh(); });
    window.addEventListener('bss_b2b:loadedObserver', registerBssHook);
    window.addEventListener('bss_b2b:module:loaded', registerBssHook);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
